function format(message) {
	var copyKey = (/mac os x/i.test(navigator.userAgent) ? "?" : "Ctrl") + "+C";
	return message.replace(/#{\s*key\s*}/g, copyKey);
}

export function copyToClipboard(text) {
	var deselectCurrent = require("toggle-selection");

	var debug,
		message,
		reselectPrevious,
		range,
		selection,
		mark,
		success = false;

	debug =  false;

	var defaultMessage = "Copy to clipboard: #{key}, Enter";

	try {
		reselectPrevious = deselectCurrent();

		range = document.createRange();
		selection = document.getSelection();

		mark = document.createElement("span");
		mark.textContent = text;
		mark.ariaHidden = "true"
		mark.style.all = "unset";
		mark.style.position = "fixed";
		mark.style.top = 0;
		mark.style.clip = "rect(0, 0, 0, 0)";
		mark.style.whiteSpace = "pre";
		mark.style.webkitUserSelect = "text";
		mark.style.MozUserSelect = "text";
		mark.style.msUserSelect = "text";
		mark.style.userSelect = "text";
		mark.addEventListener("copy", function(e) {
			e.stopPropagation();
		});

		document.body.appendChild(mark);

		range.selectNodeContents(mark);
		selection.addRange(range);

		var successful = document.execCommand("copy");
		if (!successful) {
			throw new Error("copy command was unsuccessful");
		}
		success = true;
	} catch (err) {
		debug && console.error("unable to copy using execCommand: ", err);
		debug && console.warn("trying IE specific stuff");
		try {
			window.clipboardData.setData("text", text);
			success = true;
		} catch (err) {
			debug && console.error("unable to copy using clipboardData: ", err);
			debug && console.error("falling back to prompt");
			message = format(defaultMessage);
			window.prompt(message, text);
		}
	} finally {
		if (selection) {
			if (typeof selection.removeRange == "function") {
				selection.removeRange(range);
			} else {
				selection.removeAllRanges();
			}
		}

		if (mark) {
			document.body.removeChild(mark);
		}
		reselectPrevious();
	}

	return success;
}
